import posthog from "posthog-js";

/**
 * PostHog config: key from env or fallback so analytics works without .env
 */
export const POSTHOG_KEY =
  import.meta.env.VITE_POSTHOG_KEY ??
  "phc_UOz4Qr3eBSlc3ydYR3wAiCkmzdfSSmO249PLwvbsi5z";

export function isPostHogEnabled(): boolean {
  return !!POSTHOG_KEY;
}

/** Capture an error to PostHog for product/error analytics (no PII in message). */
export function captureException(
  error: unknown,
  options?: { section?: string; extra?: Record<string, string | number | boolean | undefined | null> }
): void {
  if (!isPostHogEnabled() || typeof posthog?.capture !== "function") return;
  const message = error instanceof Error ? error.message : String(error ?? "Unknown error");
  const name = error instanceof Error ? error.name : "Error";
  const stack = error instanceof Error ? error.stack : undefined;
  posthog.capture("$exception", {
    $exception_message: message,
    $exception_type: name,
    $exception_stack_trace_raw: stack != null ? stack.slice(0, 8000) : undefined,
    section: options?.section ?? "app",
    ...options?.extra,
  });
}
